var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.684,
    height: 34.684,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3136 15.4111V10.0132C20.0478 10.7812 20.7505 11.5176 21.4531 12.2529C23.28 10.4173 24.9871 8.70156 26.7432 6.93677C27.0983 7.35073 27.3892 7.68844 27.7105 8.0621C26.0579 9.70379 24.3389 11.4098 22.6155 13.1212C23.3802 13.8609 24.1036 14.5613 24.8269 15.2607C24.7943 15.3108 24.7616 15.3609 24.7289 15.41H19.3125L19.3136 15.4111Z",
    fill: "#0F2B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94918 15.3032C10.6769 14.6081 11.4046 13.912 12.1639 13.1876C10.4002 11.4369 8.68006 9.72988 6.94141 8.00322C7.29437 7.65353 7.60157 7.3485 7.89352 7.05981C9.61692 8.79193 11.3251 10.5088 13.0517 12.2442C13.8546 11.426 14.5725 10.694 15.2904 9.96192C15.3296 9.9848 15.3688 10.0066 15.4081 10.0295V15.4273H10.0385C10.0091 15.3859 9.9786 15.3445 9.94918 15.3032Z",
    fill: "#0F2B63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4203 24.9005C14.6349 24.077 13.9278 23.3351 13.1718 22.5431C11.3874 24.3352 9.67927 26.052 7.99182 27.7471C7.66718 27.4312 7.35998 27.1305 7.04297 26.8211C8.72933 25.15 10.4462 23.4473 12.2241 21.6858C11.4092 20.908 10.6728 20.2053 9.93745 19.5038C9.96795 19.4645 9.99846 19.4242 10.029 19.385H15.4203V24.9005Z",
    fill: "#0F2B63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4915 21.4909C24.3652 23.3559 26.0854 25.0663 27.8295 26.8016C27.4623 27.1535 27.1497 27.4542 26.8545 27.7374C25.1529 26.0162 23.4512 24.295 21.6592 22.4833C20.8542 23.3516 20.1515 24.1087 19.4499 24.8647L19.3203 24.7634V19.3862H24.7356C23.9927 20.0834 23.2628 20.7676 22.4915 21.4909Z",
    fill: "#0F2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/CollapseAll.c53e032236d2b5945396f88bb65dc711.svg";
export { ForwardRef as ReactComponent };